import React from 'react';
import { Table } from 'react-bootstrap';

/**
 * A figures table with a caption, column headers, and a row header per row.
 *
 * It is the text alternative to a chart and the home of the exact numbers, so
 * a cell never carries a figure the chart does not, and the other way round.
 * A table that is wider than a narrow screen scrolls inside its own box
 * (WCAG 1.4.10); a box that scrolls must take keyboard focus, or a keyboard
 * user cannot reach the columns past the edge (WCAG 2.1.1). The region role
 * and label give that tab stop a name.
 *
 * `rows` is a list of `{ key, label, values }`, `values` being the cells
 * after the row header, already formatted. `renderCell` lets a caller style a
 * cell without this component knowing about it.
 */
function DataTable({
    caption,
    corner,
    columns,
    rows,
    className = '',
    renderCell,
}) {
    return (
        <div
            className={`table-responsive ${className}`.trim()}
            tabIndex={0}
            role="region"
            aria-label={caption}
        >
            <Table bordered size="sm" className="afe-data-table">
                <caption className="visually-hidden">{caption}</caption>
                <thead>
                    <tr>
                        <th scope="col">{corner}</th>
                        {columns.map((column) => (
                            <th key={column} scope="col">
                                {column}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row) => (
                        <tr key={row.key || row.label}>
                            <th scope="row">{row.label}</th>
                            {row.values.map((value, index) =>
                                renderCell ? (
                                    renderCell(value, row, index, columns)
                                ) : (
                                    <td key={columns[index]}>{value}</td>
                                )
                            )}
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
}

export default DataTable;
